@use '@/styles/mastodon/mixins';

.badge {
  @include mixins.type-micro;

  line-height: 1.1;

  &:not(.badgeWithoutIcon) {
    padding-inline: var(--space-3xs) var(--space-2xs);
  }
}
